import {
    mdiAccountCashOutline,
    mdiAlertOctagonOutline,
    mdiCashClock,
    mdiClipboardTextOutline,
    mdiClockAlertOutline,
    mdiCog,
    mdiDomainOff,
    mdiFileDocumentOutline,
    mdiForward,
    mdiHospitalBoxOutline,
    mdiKeyOutline,
    mdiPauseCircleOutline,
    mdiReplay,
    mdiSend,
    mdiShieldCheckOutline,
    mdiViewSplitVertical,
    mdiTimerSand,
} from '@mdi/js';
import { humanizeKey } from './configuration.utils';
import { WORKFLOW_STATUS_DESCRIPTIONS } from './configuration-worker-execution-order';

const STATUS_ICON_BY_CODE: Record<string, string> = {
    NEEDS_ENTER_CODING: mdiClipboardTextOutline,
    NEEDS_VENDOR_CODING: mdiClipboardTextOutline,
    EXECUTE_ENTER_CODING: mdiClipboardTextOutline,
    HALTED: mdiPauseCircleOutline,
    HIGH_VALUE_CLAIM_SPLIT: mdiViewSplitVertical,
    NEED_GUARANTOR_COLLECTIONS: mdiAccountCashOutline,
    NEED_PRIMARY_NON_ACKNOWLEDGED_TRANSMIT: mdiReplay,
    NEED_MEDICAL_RECORDS: mdiFileDocumentOutline,
    NEED_PRIMARY_AUTHORIZATION_NUMBER: mdiKeyOutline,
    TIMELY_FILING: mdiClockAlertOutline,
    WAIT_FOR_PROFESSIONAL_CREATED: mdiTimerSand,
    NEED_PRIMARY_RETRANSMIT: mdiReplay,
    NEED_PRIMARY_TRANSMIT: mdiSend,
    NEED_SECONDARY_TRANSMIT: mdiForward,
    NEED_TERTIARY_TRANSMIT: mdiForward,
    NEED_PRIMARY_ELIGIBILITY_CHECK: mdiShieldCheckOutline,
    PAYMENT_DENIED_FOR_HOSPICE_CARE: mdiHospitalBoxOutline,
    PAYMENT_DENIED_FOR_LACK_OF_DOCUMENTATION: mdiFileDocumentOutline,
    PAYMENT_DENIED_FOR_NEED_NEW_SUBMISSION: mdiReplay,
    DENIED_CLAIM: mdiAlertOctagonOutline,
    WAITING_FOR_PAYMENT: mdiCashClock,
    REJECTION_UNENROLLED_PAYER: mdiDomainOff,
    REJECTED_CLAIM: mdiAlertOctagonOutline,
};

export function getWorkflowStatusIcon(workflowStatus: string): string {
    return STATUS_ICON_BY_CODE[workflowStatus] ?? mdiCog;
}

export function getWorkflowStatusLabel(workflowStatus: string): string {
    return humanizeKey(workflowStatus);
}

export function getWorkflowStatusDescription(workflowStatus: string): string {
    return WORKFLOW_STATUS_DESCRIPTIONS[workflowStatus] ?? '';
}
